module.exports = __webpack_public_path__ + "static/media/water-icon.6872931d.png";